import styled from 'styled-components';

import { ACQ, COLORS } from '@/nova/theme/tokens';
import { Text } from '@/nova/components';

/** The aside column beside the overview KPI grid (parent grid stretches it to full height). A
 *  transparent layout wrapper only: it sits inside the OverviewCard container, so the counts get
 *  their OWN lifted card below rather than a second container-coloured panel that would blend in. */
export const Card = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
`;

/** The counts AND the console SSO button in one lifted tile, matching the overview KPI cards (raised
 *  `cardBase` surface, 16px radius) so they read as a single premium card. Fills the aside height; the
 *  counts center in the space above the button, which is pinned to the card's bottom edge. */
export const StatsCard = styled.div`
  flex: 1;
  background: ${ACQ.cardBase};
  border-radius: 16px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

/** Fills the space above the button (flex: 1) and centres the two counts within it, so the button
 *  sits pinned at the card's bottom edge (inside the card padding) and the stats sit centred above. */
export const Stats = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const Stat = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
  padding: 0 16px;
  text-align: center;
  /* A hairline between the two stats keeps them tidy at 50% each. Symmetric side
     padding keeps each stat's content centered in its own half. */
  &:not(:last-child) {
    border-right: 1px solid ${COLORS.hairline};
  }
`;

export const StatNum = styled(Text)`
  font-size: 40px;
  font-weight: 700;
  line-height: 1;
  color: ${COLORS.heading};
  font-variant-numeric: tabular-nums;
`;

/** Holds the console button plus its hidden measuring twin (see ManageProbe). */
export const ManageSlot = styled.div`
  position: relative;
`;

/** An invisible copy of the console button laid over the real one, carrying the FULL label forced onto one
 *  line; if that copy overflows, the full label doesn't fit and the real button shows the short one. Being the
 *  same Button, it measures with the real metrics in every language. `visibility: hidden` keeps it out of the
 *  focus order and the accessibility tree. */
export const ManageProbe = styled.div`
  position: absolute;
  inset: 0;
  visibility: hidden;
  pointer-events: none;

  /* Lay the twin out at its natural one-line size: nothing wraps and nothing shrinks (the flex row would otherwise
     squash the icon to make room, hiding part of the overflow from the measurement). */
  button > * {
    flex-shrink: 0;
    white-space: nowrap;
  }
`;

export const StatLabel = styled(Text)`
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.01em;
  color: ${COLORS.textMuted};
`;
